import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { setOneTrustState } from '@/features/auth/slice'
import { getMediaState } from '@/features/media/slice'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { useCatPrivacyNotice } from './useCatPrivacyNotice'
import { usePerkinsPrivacyNotice } from './usePerkinsPrivacyNotice'

interface Props {
  open: boolean
}

export default function OneTrustModal(props: Props) {
  const { open } = props
  const dispatch = useAppDispatch()

  const isPerkins = useAppSelector(getMediaState).isPerkins
  usePerkinsPrivacyNotice(isPerkins && open)
  useCatPrivacyNotice(!isPerkins && open)
  const company = isPerkins ? 'emc.perkins.com' : 'emc.cat.com'
  const id = isPerkins
    ? 'otnotice-f97baac8-60e1-4428-9d25-0945703c42c5'
    : 'otnotice-7f61a611-db7f-40a6-877f-fa0ae844b1bf'

  return (
    <Dialog open={open}>
      <DialogTitle>Privacy notice for {company}</DialogTitle>

      <DialogContent>
        <div id={id} className="otnotice" style={{ paddingTop: '16px' }}></div>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => dispatch(setOneTrustState({ open: false }))}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
